import React from "react";

import Search from "assets/icons/search.svg";
import styles from "./SearchFrequencyRequestPreview.module.scss";

type Props = {
  sts: {
    st: string;
    amount: number;
  };
  onFrequencyRequestClick: (st: string) => void;
};
const SearchFrequencyRequestPreview = ({
  sts,
  onFrequencyRequestClick,
}: Props) => {
  return (
    <div
      className={styles.frequencyRequestPreviewWrapper}
      onClick={() => onFrequencyRequestClick(sts.st)}
    >
      <Search className={styles.frequencyRequestPreviewSearch} />
      <div className={styles.title}>{sts.st}</div>
    </div>
  );
};

export default SearchFrequencyRequestPreview;
